<div class="poster-text-view">
  <div class="position-handler" [ngStyle]="getPosition()">
    <p [ngStyle]="textModel.style">
      {{textModel.value}}
    </p>
  </div>
</div>
